module.exports = __webpack_public_path__ + "img/personal-incomelog.3c5186aa.svg";